import React from 'react';

const SITE_URL = 'https://coachginge.com';
const HALLOWEEN_URL = 'https://www.youtube.com/playlist?list=PLbQA9r4RaJ3Y';

const post = {
  slug: 'coach-ginge-halloween',
  title: 'Coach Ginge does Halloween',
  date: '2026-10-08',
  cover: '/blog/coach-ginge-halloween/cover.jpg',
  coverAlt:
    'Coach Ginge in a witch hat beside a tower of jack-o’-lanterns, with Sugar, Fluffy and Boo the friendly ghost kitten, and the words Flap! Float! Freeze!',
  excerpt:
    'Five free Halloween brain breaks, one every couple of days until 16 October, and a new friend: Boo, the friendly ghost kitten.',
  content: (
    <>
      <p>
        A week ago Coach Ginge{' '}
        <a href="/blog/coach-ginge-for-kids">went back to school</a> with three
        brain breaks for children. A fourth, Beach Dash, followed. Then the
        shops filled up with pumpkins, and it was obvious what came next.
      </p>

      <h2>Five brain breaks for Halloween</h2>
      <p>
        UK classes do their Halloween the week before half term, so we set
        ourselves a deadline: five brain breaks, all out by Friday 16 October.
        Each one is three to four minutes long, done standing up, with no
        equipment. Every move is called before it comes, as before.
      </p>
      <ul>
        <li>
          <strong>Halloween Dance-Along</strong> (out now). A felt pumpkin
          patch at dusk. Step on the glowing paw prints, flap like a bat and
          watch the pumpkin tower grow.
        </li>
        <li>
          <strong>Halloween Freeze Dance</strong> (Friday 9 October). Three
          spooky-silly songs. When the music stops, freeze like a scarecrow, a
          ghost or a bat.
        </li>
        <li>
          <strong>Halloween Pose Wall</strong> (Monday 12 October). Felt walls
          come down the pumpkin patch with a shape cut out of each one. Copy
          the shape and fit through.
        </li>
        <li>
          <strong>Halloween Laser Dot Run</strong> (Wednesday 14 October). The
          laser dot is loose in four Halloween worlds, from the pumpkin patch
          at sunset to a moonlit cat castle.
        </li>
        <li>
          <strong>Halloween Would You Rather?</strong> (Friday 16 October).
          Would you rather fly like a bat, or float like a ghost? Pick a move
          and do it, then see what Boo picked.
        </li>
      </ul>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/IRCdzHXyaAc"
          title="Halloween Dance-Along, a brain break for kids with Coach Ginge"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h2>Spooky, but not scary</h2>
      <p>
        The audience is four to nine, so Halloween here means witch hats,
        pumpkins and bats, never anything with teeth. Coach Ginge and his
        friends got hats and a party feel, and the cast got a new member: Boo,
        a little ghost kitten who floats along beside them and joins in with
        every move. If anything, he is the least scary character on the
        channel.
      </p>

      <div className="post-photo-grid">
        <img
          src="/blog/coach-ginge-halloween/pose-wall.jpg"
          alt="Halloween Pose Wall: the cats in Halloween hats making shapes before a felt wall in a pumpkin patch"
        />
        <img
          src="/blog/coach-ginge-halloween/would-you-rather.jpg"
          alt="Halloween Would You Rather: Coach Ginge flying like a bat on one side, Fluffy floating with Boo on the other"
        />
      </div>

      <h2>Would you rather?</h2>
      <p>
        The newest one is a different kind of game. There are twelve questions,
        and each one has two moves. Coach Ginge shows one of them in orange and
        Fluffy shows the other in purple, so a child who can&apos;t read yet can
        still choose by colour and by cat. Everyone does their pick until the
        countdown ends, and then Boo swoops over to show what he picked. He
        picks each side about half the time, so there is never a wrong answer.
      </p>

      <h2>For teachers</h2>
      <p>
        <a href={SITE_URL}>coachginge.com</a> has a new Halloween section and
        a Halloween teacher card to print. The card gives the five videos with
        their moves, a QR code for each one and the day it comes out. All five
        are also in one{' '}
        <a href={HALLOWEEN_URL}>Halloween Brain Breaks playlist</a>, which fills
        up as each one is released.
      </p>

      <figure className="post-figure">
        <img
          src="/blog/coach-ginge-halloween/teacher-card.jpg"
          alt="The Halloween teacher card: five brain breaks, each with its thumbnail, moves, release day and QR code"
        />
        <figcaption>The Halloween teacher card, free on coachginge.com.</figcaption>
      </figure>

      <div className="post-callout">
        <h3>Know a teacher planning a Halloween party?</h3>
        <p>
          Send them to <a href={SITE_URL}>coachginge.com</a>. Five Halloween
          brain breaks, a few minutes each, cosy and friendly, never scary.
        </p>
      </div>

      <p className="post-signoff">
        For Grandad, who would have sat on the pumpkins.
      </p>
    </>
  ),
};

export default post;
